import api from "../utils/api";

/**
 * Fetch today's updates for the dashboard feed.
 * @param {Object} options
 * @param {number} [options.limit=3] - Max items to return (page shows 3; modal fetches more).
 * @returns {Promise<{ updates: Array, total: number }>}
 */
export const getTodaysUpdates = async ({ limit = 3 } = {}) => {
  const response = await api.get("/dashboard/todays-updates", {
    params: { limit },
  });
  const data = response.data?.data ?? {};
  return {
    updates: data.updates ?? [],
    total: data.total ?? 0,
  };
};
